import { LOAN_STATUS } from 'components/LoansAndAdvances/constants';

export const ADMIN_ACTIVE_LOAN_KEY = 'ADMIN_ACTIVE_LOAN';
export const ADMIN_LOAN_DETAIL_KEY = 'ADMIN_LOAN_DETAIL';
export const BASIC_USER_LOAN_DATA_KEY = 'BASIC_USER_LOAN_DATA_EDIT';
export const BASIC_USER_LOAN_DATA_DRAWER_KEY = 'BASIC_USER_LOAN_DATA_DRAWER';
export const ACTIVE_LOANS_BY_USER_KEY = 'ACTIVE_LOANS_BY_USER';
export const LOAN_CALCULATE_KEY = 'LOAN_CALCULATE';
export const MODIFY_LOAN_DETAIL_KEY = 'MODIFY_LOAN_DETAIL';
export const MODIFY_PREVIEW_KEY = 'MODIFY_PREVIEW';
export const SKIP_LOAN_DETAIL_KEY = 'SKIP_LOAN_DETAIL';
export const SKIP_PREVIEW_KEY = 'SKIP_PREVIEW';
export const RECOVERY_LOAN_DETAIL_KEY = 'RECOVERY_LOAN_DETAIL';
export const FULL_RECOVERY_AMOUNT_KEY = 'FULL_RECOVERY_AMOUNT';
export const PARTIAL_RECOVERY_PREVIEW_KEY = 'PARTIAL_RECOVERY_PREVIEW';

export const LOAN_MODAL = {
  APPROVE: 'approve',
  REJECT: 'reject',
  EDIT_APPROVE: 'edit-approve',
} as const;
export const RECOVERY_PREVIEW_KEY = 'ADMIN_RECOVERY_PREVIEW';

export const INTEREST_TYPE_LABEL: Record<number, string> = {
  1: 'Flat Interest',
  2: 'Reducing',
  3: 'Greyt Reducing Intrest',
  4: 'Interest Free',
};

export const BADGE_TO_ICON_COLOR: Record<string, string> = {
  notice: 'feedback.icon.notice.intense',
  positive: 'feedback.icon.positive.intense',
  negative: 'feedback.icon.negative.intense',
  neutral: 'surface.icon.gray.muted',
  information: 'interactive.icon.primary.normal',
};

export const EMI_STATUS_COLOR: Record<number, 'positive' | 'notice' | 'neutral' | 'information'> = {
  1: 'positive',
  2: 'notice',
  3: 'neutral',
  4: 'information',
  5: 'information',
};

export const EMI_STATUS_LABEL: Record<number, string> = {
  1: 'Paid',
  2: 'Pending',
  3: 'Skipped',
  4: 'Partial Recovery',
  5: 'Full Recovery',
};

export const TAB_PENDING = 'pending-approval';
export const TAB_COMPLETED = 'completed';

export const TAB_STATUS_MAP: Record<string, number[]> = {
  [TAB_PENDING]: [LOAN_STATUS.PENDING],
  [TAB_COMPLETED]: [LOAN_STATUS.APPROVED, LOAN_STATUS.REJECTED],
};

export const REJECTION_REASONS = [
  'Amount too high',
  'Existing loan active',
  'Insufficient tenure',
  'Inadequate documentation',
];

export const INTEREST_TYPES = [
  {
    value: '4',
    label: 'Interest-Free (0%)',
    description:
      'The employee only repays the principal amount without paying any additional interest charges',
  },
  {
    value: '1',
    label: 'Flat Interest',
    description:
      'Calculated on the entire initial loan amount, regardless of payments made by the employee',
  },
  {
    value: '2',
    label: 'Reducing Interest',
    description:
      'Calculated only on the remaining balance of the loan, which decreases after each EMI payment',
  },
];
